import { useEffect } from "react";

const SetmoreBooking = ({buttonTextComponent}) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.id = "setmore_script";
    script.type = "text/javascript";
    script.src = "https://assets.setmore.com/integration/static/setmoreIframeLive.js";
    document.body.appendChild(script);
  }, []);

  return (
    <a
      id="Setmore_button_iframe"
      href="https://onceuponamat-com.setmore.com"
      style={{ float: "none" }}
    >
        {buttonTextComponent}
      {/* <img
        border="none"
        src="https://assets.setmore.com/setmore/images/2.0/Settings/book-now-black.svg"
        alt="Book an appointment with Однажды на коврике using Setmore"
      /> */}
    </a>
  );
};

export default SetmoreBooking;
